import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import classes from './About.module.css';

const AcerdaDe = () => {
    return(
        <Container>
            <Row>
                <Col className="title-container">
                    <div>
                        <h1>Acerca de Soy Mentor</h1>
                    </div>
                </Col>
            </Row>
            <Row>
              <p>El Programa de Mentoreo Voluntario representa la oportunidad que tenemos como profesionistas, de orientar a estudiantes, que buscan tener éxito y bienestar en su carrera.</p>
              
              <div>
                  <ul>
                      <li>
                          <p>Los estudiantes enfrentan, desde su ingreso a la universidad, grandes retos de integración tanto académica como social en la que contar con la orientación de alguien que ya pasó por ese proceso, puede marcar la diferencia para tener éxito.</p>
                      </li>
                      <li>
                          <p>¿Recuerdas a las personas que te apoyaron y orientaron mientras estudiabas? ¿Te dedicaron parte de su tiempo de forma voluntaria? ¡Ahora tu puedes ser esa persona y trascender en la vida de alguien mas!</p>
                      </li>
                      <li>
                          <p>Hoy en día, los profesionistas cuentan con muy poco tiempo para hacer algo por la sociedad, por eso, hemos creado un programa flexible en el que invertirás el tiempo que tengas disponible para esta labor.</p>
                      </li>
                  </ul>
              </div>

              <p>Lo más importante para la Universidad es que cada alumno que se inscriba a un programa académico, pueda concluirlo de manera exitosa, con claridad en su propósito de vida y con las competencias necesarias para cumplirlo.</p>
              
              <p>Este programa tiene como <strong>objetivo principal:</strong></p>
              <p>Ser el punto de encuentro de la comunidad de Universidad Tecmilenio que permita construir relaciones positivas de mentoreo para el éxito y bienestar de sus integrantes, desarrollando las competencias necesarias para asumir con éxito los retos que se les presenten en su vida.</p>

              <p>Los <strong>beneficios para los estudiantes</strong> son:</p>
              <ul>
                  <li><p>Contar con un mentor que lo pueda asesorar durante su estancia en la Universidad</p></li>
                  <li><p>Construir competencias clave que le permitan tener éxito en la universidad (ej. Desarrollo de relaciones interpersonales, integración a un nuevo ambiente, administración del tiempo, resiliencia, técnicas de estudio, etc.)</p></li>
                  <li><p>Conocer más acerca del área profesional de su interés de la mano de un profesionista (su mentor)</p></li>
                  <li><p>Apoyo en la definición de objetivos profesionales alineados al cumplimiento de su propósito de vida</p></li>
                  <li><p>Vincularse con personas del sector productivo desde sus inicios universitarios</p></li>
              </ul>

              <p>Los <strong>beneficios para los mentores voluntarios </strong>son:</p>
              <ul>
                  <li><p>Tener la satisfacción de ayudar a otras personas</p></li>
                  <li><p>Desarrollar habilidades de liderazgo positivo: Un buen líder sabe que una de sus principales responsabilidades es el desarrollar a su equipo. Aprovecha esta oportunidad para poner en práctica esta habilidad</p></li>
                  <li><p>Buscar el mejor talento: Puedes encontrar jóvenes con gran potencial que en su momento se podrían integrar en tu organización o que te podrían conectar con otros jóvenes con potencial</p></li>
                  <li><p>Aprovechar las ideas y habilidades de las nuevas generaciones</p></li>
                  <li><p>Alimentar tu pasión: Comparte lo que te apasiona con otras personas que buscan desarrollarse en áreas similares</p></li>
                  <li><p>Obtener herramientas que podrás aplicar no sólo en tu organización, sino en tu vida personal</p></li>
              </ul>

              <p><strong>“La satisfacción de dar es una emoción que supera a la de recibir”,</strong> <em>Martin Seligman</em>.</p>

              <div className="col-md-6">
                  <h2>Regístrate como mentor</h2>
                  <p>
                      Conviertete en un mentor voluntario: ya seas colaborador profesor o alumno de Universidad Tecmilenio, o trabajas en una empresa con convenio, puedes cambiar la vida de cientos de estudiantes.
                  </p>
                  <p>
                    <a href="/quiero-ser-mentor">
                      <input type="button" className={classes.registro} value="Registro" />
                    </a>
                  </p>
                  <img alt='Imagen' src="/images/Imagen1.jpg"></img>
              </div>
            </Row>
        </Container>
    )
}
export default AcerdaDe;